export const SEVERITY_COLORS: Record<number, string> = { 1: "#f2c744", 2: "#d9720e", 3: "#9e2b25" };
export const DEFAULT_COLOR = "#3498db";

const SEVERITY_WEIGHTS: Record<number, number> = { 1: 1, 2: 2, 3: 3 };
const DEFAULT_WEIGHT = 1;

export const VOIVODESHIPS: ReadonlyArray<readonly [string, string]> = [
  ["02", "dolnośląskie"],
  ["04", "kujawsko-pomorskie"],
  ["06", "lubelskie"],
  ["08", "lubuskie"],
  ["10", "łódzkie"],
  ["12", "małopolskie"],
  ["14", "mazowieckie"],
  ["16", "opolskie"],
  ["18", "podkarpackie"],
  ["20", "podlaskie"],
  ["22", "pomorskie"],
  ["24", "śląskie"],
  ["26", "świętokrzyskie"],
  ["28", "warmińsko-mazurskie"],
  ["30", "wielkopolskie"],
  ["32", "zachodniopomorskie"],
];

export function voivodeshipName(terytPrefix: string): string {
  return VOIVODESHIPS.find(([code]) => code === terytPrefix)?.[1] ?? terytPrefix;
}

export function severityColor(severity: number): string {
  return SEVERITY_COLORS[severity] ?? DEFAULT_COLOR;
}

export function severityWeight(severity: number): number {
  return SEVERITY_WEIGHTS[severity] ?? DEFAULT_WEIGHT;
}

const PHENOMENON_DISPLAY_NAMES: Record<string, string> = {
  SH: "Susza hydrologiczna",
  GWSW: "Gwałtowne wzrosty stanów wód",
};

export function displayPhenomenon(phenomenon: string): string {
  const mapped = PHENOMENON_DISPLAY_NAMES[phenomenon.toUpperCase()];
  if (mapped) return mapped;
  return phenomenon ? phenomenon[0].toUpperCase() + phenomenon.slice(1) : phenomenon;
}

const SOURCE_LABELS: Record<string, string> = {
  imgw: "IMGW",
  open_meteo: "prognoza",
};

export function sourceLabel(source: string): string {
  return SOURCE_LABELS[source] ?? source;
}
